import {
  Component,
  computed,
  inject,
  signal,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Data, Router, RouterModule } from '@angular/router';
import { Dataset, ItemListResponse, Label } from '@models';
import {
  AuthService,
  DatasetService,
  NotificationService,
  TitleService,
} from '@services';
import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { LeafletGroupComponent } from '@components/leaflet/group/group.component';
import { MarkdownPipe, ResolveUserPipe } from '@pipes';
import { MatListModule } from '@angular/material/list';
import { MatChipsModule } from '@angular/material/chips';
import { DatasetListComponent } from '../list/list.component';
import { environment } from '@environment';
import { httpResource } from '@angular/common/http';

@Component({
  selector: 'app-dataset-metadaa',
  templateUrl: './metadata.component.html',
  styleUrls: ['./metadata.component.scss'],
  imports: [
    RouterModule,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatMenuModule,
    MatListModule,
    MatChipsModule,
    LeafletGroupComponent,
    MarkdownPipe,
    ResolveUserPipe,
  ],
})
export class DatasetMetadataComponent {
  @ViewChild('publishPromptTemplate')
  publishPromptTemplateRef!: TemplateRef<unknown>;

  route = inject(ActivatedRoute);
  clipboard = inject(Clipboard);
  dialog = inject(MatDialog);
  router = inject(Router);
  notificationService = inject(NotificationService);
  datasetService = inject(DatasetService);
  titleService = inject(TitleService);
  authService = inject(AuthService);

  dataset = signal<Dataset>(this.route.snapshot.parent!.data['dataset']);

  labels = httpResource<Label[]>(
    () => `${environment.kinkoHost}/label/?type=project&take=255&datasetId=${this.dataset().id}`,
    {
      parse: (resp) => (resp as ItemListResponse<Label>).items,
    }
  );

  url = computed(() => `https://doi.org/${this.dataset().doi.toUpperCase()}`);
  publicationYear = computed(() => this.dataset().published.substring(0, 4));
  authors = computed(() => DatasetListComponent.authors(this.dataset()));

  constructor() {
    this.route.data.subscribe((data: Data) => {
      this.dataset.set(data['dataset']);
      this.titleService.setTitle(this.dataset().content.title);
    });
  }

  public copyToClipboard() {
    const text = `${this.authors()} (${this.publicationYear()}). ${this.dataset().content.title} [Dataset]. Norwegian Polar Institute. ${this.url()}`;

    if (this.clipboard.copy(text)) {
      this.notificationService.success('Citation copied to clipboard.');
    } else {
      this.notificationService.warning('Failed to access clipboard.');
    }
  }
}
